/* ============================================================================
   PDP gallery progress bar (mobile)
   Adds ONE continuous progress bar overlaid on the product image; the fill
   grows with the current image position (index / total). Mobile only (CSS
   hides it on desktop). Self-contained, degrades gracefully.
   ========================================================================== */
(function () {
  'use strict';

  function initOne(car) {
    if (car.__pgpInit) return;
    car.__pgpInit = true;

    var list = car.closest('.product-gallery__image-list');
    if (!list) return;

    var bar = document.createElement('div');
    bar.className = 'pdp-gallery-progress';
    var fill = document.createElement('div');
    fill.className = 'pdp-gallery-progress__fill';
    bar.appendChild(fill);
    list.appendChild(bar);

    function total() {
      return car.querySelectorAll('.product-gallery__media:not([hidden])').length || 1;
    }

    function update() {
      var count = total();
      if (count <= 1) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      var w = car.clientWidth || 1;
      var idx = Math.round(car.scrollLeft / w);
      if (idx < 0) idx = 0;
      if (idx > count - 1) idx = count - 1;
      fill.style.width = ((idx + 1) / count * 100) + '%';
    }

    var raf;
    car.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function setup() {
    document.querySelectorAll('.product-gallery__carousel').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(setup, 60); });
})();
